// extracted by mini-css-extract-plugin
export default {"root":"VirtualAccounts_root__LLjrW"};